const svg = `
    <svg
    width="100" height="100"
    version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
  viewBox="0 0 50 55" style="enable-background:new 0 0 50 50;" xml:space="preserve"
    >

      <style type="text/css">
        .path {
          fill: #222;
          stroke: #222;
          stroke-width: 0;
          animation: logo 5s linear infinite;
        }

        @keyframes logo {
          0% {
            stroke-width: 1pt;
            stroke-dashoffset: 500;
            fill-opacity: 0;
          }
          10% {
            fill-opacity: 0;
          }
          60% {
            stroke-dashoffset: 0;
            fill-opacity: 1;
            stroke-width: 0pt;
          }
          100% {
            stroke-dashoffset: 0;
            fill-opacity: 1;
            stroke-width: 0pt;
          }
        }
      </style>

      <path
        class="path"
        strokeDasharray="500 500"
        d="M16.4033 41.8193L39.446 41.8193L26.4839 8.69402L18.5626 8.69402L2 41.8193L10.6414 41.8193L22.1632 19.4957L27.204 34.6182H20.0028L16.4033 41.8193Z"
      ></path>
    </svg>`;

const svgDataUrl = `data:image/svg+xml;base64,${btoa(svg)}`;

console.log(
  '%c ',
  `
background-image: url(${svgDataUrl});
padding-bottom: 150px;
padding-left: 150px;
margin-left: 25px;
background-size: contain;
background-position: center center;
background-repeat: no-repeat;
`,
);

console.log(
  `
%cPowered by Awtomic
%cthe ultimate repeat purchase platform.
%cSUBSCRIPTIONS ■ LIFECYCLE MARKETING ■ BUNDLING ■ ADD-ONS & UPSELLS ■ AUTOMATIONS
%chttps://awtomic.com
`,
  `
font-size: 20px;
font-weight: 600;
color: #000;
margin-top: 10px
`,
  `
font-size: 19px;
font-weight: 600;
margin-top: 5px;
color: #3700ff;
`,
  `
font-size: 16px;
margin-top: 25px;
color: #000;
`,
  `
font-size: 15px;
margin-top: 25px;
color: #000;
`,
);
